export type CollapsedBoardColumns = Record<string, string[]>;

export function isBoardColumnCollapsed(state: CollapsedBoardColumns, collectionId: string, column: string): boolean {
  return (state[collectionId] || []).includes(column);
}

export function toggleBoardColumn(state: CollapsedBoardColumns, collectionId: string, column: string): CollapsedBoardColumns {
  const current = new Set(state[collectionId] || []);
  if (current.has(column)) current.delete(column); else current.add(column);
  return withCollection(state, collectionId, [...current]);
}

export function collapseOtherBoardColumns(state: CollapsedBoardColumns, collectionId: string, columns: string[], keep: string): CollapsedBoardColumns {
  return withCollection(state, collectionId, columns.filter(column => column !== keep));
}

export function expandBoardColumns(state: CollapsedBoardColumns, collectionId: string): CollapsedBoardColumns {
  return withCollection(state, collectionId, []);
}

function withCollection(state: CollapsedBoardColumns, collectionId: string, columns: string[]): CollapsedBoardColumns {
  const nextColumns = [...new Set(columns)];
  const next = { ...state };
  if (nextColumns.length) next[collectionId] = nextColumns;
  else delete next[collectionId];
  return next;
}
